import { useMemo } from "react";
import { ethers } from "ethers";
import { useWallet } from "../context/WalletContext";
import { NEXAURA_ADDRESS, NEXAURA_ABI } from "../config/contract";
import { NETWORK } from "../config/network";

// Read-only fallback provider so the app can show public data even before connect.
let _readProvider = null;
function readProvider() {
  if (!_readProvider) {
    _readProvider = new ethers.providers.JsonRpcProvider(NETWORK.rpcUrls[0]);
  }
  return _readProvider;
}

// Returns { read, write } contract instances. `write` is null until connected.
export function useContract() {
  const { account, getSigner, getProvider, isCorrectNetwork } = useWallet();

  return useMemo(() => {
    const provider = getProvider() || readProvider();
    const read = new ethers.Contract(NEXAURA_ADDRESS, NEXAURA_ABI, provider);

    let write = null;
    if (account && isCorrectNetwork) {
      const signer = getSigner();
      if (signer) write = new ethers.Contract(NEXAURA_ADDRESS, NEXAURA_ABI, signer);
    }
    return { read, write };
  }, [account, isCorrectNetwork]);
}
